/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {PassportBranding} from './BrandDomain';

export type PassportDto = {
  id: string;
  metadata?: PassportMetadataDto;
  data: any;
};

export type PassportMetadataDto = {
  status: {
    state: 'inactive' | 'active';
    status: StatusStringEnum;
  };
  masterChildFlag: MasterChildStringEnum;
  qrCodeContent: string;
  masterPassportId?: string;
  schemaId?: string;
  name?: string;
  progress?: ProgressDto;
  organizationId?: string;
  createdAt?: string;
  updatedAt?: string;
  /** Scan-page branding resolved by the backend for public reads; absent = platform default. */
  branding?: PassportBranding;
  /** Non-blocking warnings returned on creation (e.g. unmatched UBI root domain). */
  warnings?: string[];
};

type ProgressDto = {
  count: number;
  total: number;
  sections: Record<string, 'complete' | 'incomplete' | 'untouched'>;
};

export enum StatusStringEnum {
  DRAFT = 'draft',
  COMPLETED = 'complete',
}

export enum MasterChildStringEnum {
  MASTER = 'MASTER',
  CHILD = 'CHILD',
}
